export const style = {
  mainOrangeColor: '#efae26',
  lightGrey: '#d9d9d9',
}
